import { GetServerSidePropsContext } from 'next';
import { Languages } from 'core/localization/entities';

export type StaticProps = {
  params: {
    id?: string;
    funnel: string;
  };
  locale: Languages;
};

export type ServerSideProps = {
  params: {
    id?: string;
    funnel: string;
    options: [string, string, string];
  };
  query?: Record<string, string>;
  locale: Languages;
  req: GetServerSidePropsContext['req'];
  res: GetServerSidePropsContext['res'];
};

export type DraftFlowSSRProps = {
  params: {
    options: [string, string, string];
  };
  locale: Languages;
};

export type StaticPathProps = {
  locales: Languages[];
  defaultLanguage: Languages;
};

export enum FunnelStatus {
  ACTIVE = 'active',
  NOT_ACTIVE = 'not_active',
}

export enum FlowStatus {
  ACTIVE = 'active',
  NOT_ACTIVE = 'not_active',
}

export type FunnelRequestFilters = {
  funnelName: string;
  funnelStatus: FunnelStatus;
  language: Languages;
  flowName: string;
  flowStatus: FlowStatus;
};
